import React from "react";
import TrainerMode from "../../../components/TrainerMode/TrainerMode";

function TrainerModePage() {
  return <TrainerMode />;
}

export default TrainerModePage;
